<template lang="pug">
div
	.mb-6(v-for="airport in airports")
		h3
			nuxt-link.black--text(:to="localePath({name: 'airports-airport', params: {airport: airport.node.slug}})" :title="airport.node.name") {{airport.node.name}}
		factline
			li(icon="distance")  {{airport.distance}}km
			li(icon="clock-o") {{$t('page.areas._area.reachability:{time}_to_drive', {time: formatMinutes(airport.minutes)})}}
			li(icon="plane") {{$tc('page.areas._area.reachability:flights_{count}', airport.node.flights)}}
		v-list(v-if="airport.node.airlines" subheading dense)
			template(v-for="airline in airport.node.airlines")
				v-divider
				v-list-item(:to="`/redir?u=${encodeURIComponent(airline.url)}&p=${airline.airline.id}&i=${airline.id}&t=airline&h=${$redirHash(airline.url)}`" target="_blank" rel="nofollow").pl-2.pr-0
					v-list-item-content
						v-list-item-title(style="font-size:15px")
							span.font-weight-bold.primary--text {{airline.airline.name}}
							|
							| {{$t('page.areas._area.reachability:price_from')}}
							|
							span.orange--text.font-weight-bold €{{airline.price}},-
					v-list-item-action.ma-0
						v-btn.body-2(color="warning" small depressed ) {{$t('page.areas._area.reachability:check_button')}}

</template>

<script>
import areasReachability from '@/mixins/areas-reachability.js';

export default {
	mixins: [areasReachability],
	props: {
		airports: {
			type: Array,
			default: () => []
		}
	}
};
</script>
